type Unsubscribe = () => void;

/**
 * @description To be used for getting audio level from the media stream.
 * @param audioTrack Audio track to listen to
 * @param callback Get audio buffer updates
 * @param bufferSize Customize the buffer size. By default it is sampleRate / 50
 * @param _AudioContext - Internal parameter for Dependency Injection [DO NOT USE]
 * @param _AudioWorkletNode - Internal parameter for Dependency Injection [DO NOT USE]
 * @returns {Unsubscribe} - Unsubscribe function
 */
export const subscribeForAudioBuffer = async (
  audioTrack: MediaStreamTrack,
  callback: (buffer: Float32Array) => void,
  bufferSize?: number,
  _AudioContext = AudioContext,
  _AudioWorkletNode = AudioWorkletNode,
): Promise<Unsubscribe> => {
  const audioContext = new _AudioContext();
  await audioContext.audioWorklet.addModule(
    '/v2/worklet/audioBufferProcessor.js',
  );
  const sourceNode = audioContext.createMediaStreamSource(
    new MediaStream([audioTrack]),
  );
  const audioLevelNode = new AudioWorkletNode(
    audioContext,
    'audio-buffer-worklet-processor',
    { processorOptions: { bufferSize } },
  );
  sourceNode.connect(audioLevelNode).connect(audioContext.destination);

  // eslint-disable-next-line unicorn/prefer-add-event-listener
  audioLevelNode.port.onmessage = ({
    data: { buffer },
  }: {
    data: { buffer: Float32Array };
  }): void => {
    callback(buffer);
  };

  return () => {
    audioContext.suspend().catch((error) => console.error(error));
  };
};
